import { useMemo } from 'react'

import autopilotCopyJson from '../../demo/fixtures/w3/copy.json'
import { selectTrackedCampaigns } from '../../demo/selectors'
import { useDemoStore } from '../../demo/store'
import type { Campaign, TrackedCampaign } from '../../demo/types'
import type { MonitorTabKey } from './compliance'

export const AUTOPILOT_TAB = {
  key: 'autopilot',
  label: autopilotCopyJson.monitorTab,
} as const

export const AUTOPILOT_COPY = {
  column: autopilotCopyJson.monitorCol,
  empty: autopilotCopyJson.monitorEmpty,
} as const

export function useTrackedCampaigns(): TrackedCampaign[] {
  const campaigns = useDemoStore((state) => state.campaigns)
  const autopilotByCampaign = useDemoStore((state) => state.autopilotByCampaign)
  const optimizations = useDemoStore((state) => state.optimizations)

  return useMemo(() => {
    void campaigns
    void autopilotByCampaign
    void optimizations
    return selectTrackedCampaigns()
  }, [campaigns, autopilotByCampaign, optimizations])
}

export function filterAutopilotCampaigns(
  campaigns: Campaign[],
  tab: MonitorTabKey,
  trackedCampaigns: TrackedCampaign[],
): Campaign[] {
  if (tab !== AUTOPILOT_TAB.key) return campaigns
  const campaignsById = new Map(campaigns.map((campaign) => [campaign.id, campaign]))
  return trackedCampaigns.flatMap(({ campaign }) => {
    const match = campaignsById.get(campaign.id)
    return match ? [match] : []
  })
}
